import React from 'react';
import { Facebook, Instagram, Linkedin, Building2, Twitter, Globe } from 'lucide-react';

interface PlatformIconProps {
  platform: string;
  className?: string;
}

export const PlatformIcon: React.FC<PlatformIconProps> = ({ platform, className = "w-5 h-5" }) => {
  switch (platform.toLowerCase()) {
    case 'facebook':
      return <Facebook className={`${className} text-blue-600`} />;
    case 'instagram':
      return <Instagram className={`${className} text-pink-600`} />;
    case 'linkedin':
      return <Linkedin className={`${className} text-blue-700`} />;
    case 'google_business':
      return <Building2 className={`${className} text-red-600`} />;
    case 'x':
      return <Twitter className={`${className} text-black`} />;
    default:
      return <Globe className={`${className} text-gray-600`} />;
  }
};